module.exports = __webpack_public_path__ + "static/media/s66.e162b5d1.jpg";